import { axiosWithAuth } from "../../helpers";

export const agentOfficeSetupService = {
	getAgentOfficesList,
	getMoreAgentOfficeSetupData,
	getPrimaryContacts,
	addAgentOfficeForm,
	getEditAgentOfficeForm,
	editAgentOfficeForm,
	getAgents,
	getMerchantsList,
	getNotificationTemplates,
	getESignAccounts,
	saveNotificationMessageTemplatesForm,
	getCheckOfficeName,
	getFeeTemplates,
	changeFeeTemplateStatus,
	reorderFeeTemplate,
	copyFeeTemplate,
	deleteFeeTemplate,
	saveTsysAccount,
	saveRiservAccount,
	getTsysCredentials,
	getFDCredentials,
	getAgentOfficeHierarchy,
	getAgentOfficeHistory,
	changeFeeTemplateDefault,
	getAgentOfficeApi,
	generateAgentOfficeApi,
	regenerateAgentOfficeApi,
	getWhitelistedDomains,
	ariseBoarding,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getAgentOfficesList({ page, sort, filtersApplied }) {
	const businessUnit = filtersApplied?.businessUnit?.parent
		? filtersApplied?.businessUnit?.parent?.name
		: filtersApplied?.businessUnit?.name;

	const businessUnitHierarchy =
		filtersApplied?.businessUnit?.parent &&
		filtersApplied?.businessUnit?.name;

	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			office_name: filtersApplied?.officeName,
			package: filtersApplied?.package?.value,
			phone: filtersApplied?.phone,
			primary_contact: filtersApplied?.primaryContact,
			business_unit: businessUnit,
			business_unit_hierarchy: businessUnitHierarchy,
			sort_type: sort?.id || undefined,
			ascending: sort?.id ? sort?.desc : undefined,
		},
		url: `${API_URL}/api/companies`,
	};

	return axiosWithAuth(options);
}

function getMoreAgentOfficeSetupData(primaryContactId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/primary-contacts/${primaryContactId}`,
	};

	return axiosWithAuth(options);
}

function getPrimaryContacts(companyId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/primary-contacts`,
	};

	return axiosWithAuth(options);
}

function addAgentOfficeForm(model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/companies`,
	};

	return axiosWithAuth(options);
}

function editAgentOfficeForm(companyId, model) {
	const options = {
		method: "PUT",
		data: model,
		url: `${API_URL}/api/companies/${companyId}/general`,
	};

	return axiosWithAuth(options);
}

// Request for Edit Agent Office Tabs

function getEditAgentOfficeForm(companyId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/general`,
	};

	return axiosWithAuth(options);
}

// Request for Agent Tab in Edit Agent Office

function getAgents(companyId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/agents`,
	};

	return axiosWithAuth(options);
}

// Request for List of Merchants Tab in Edit Agent Office

function getMerchantsList(companyId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/merchants`,
	};

	return axiosWithAuth(options);
}

// Request for Notification Message Templates Tab in Edit Agent Office

function getNotificationTemplates(companyId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/templates`,
	};

	return axiosWithAuth(options);
}

function getESignAccounts() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/esign-accounts`,
	};

	return axiosWithAuth(options);
}

function saveNotificationMessageTemplatesForm(companyId, model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/companies/${companyId}/templates`,
	};

	return axiosWithAuth(options);
}

function getCheckOfficeName(name) {
	const options = {
		method: "GET",
		params: { name },
		url: `${API_URL}/api/companies/check-if-exists`,
	};

	return axiosWithAuth(options);
}

// Additional Fee Templates Tab

function getFeeTemplates(companyId, templatePage, isActive) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/fields-templates`,
		params: { templatePage, isActive },
	};

	return axiosWithAuth(options);
}

function changeFeeTemplateStatus(companyId, templateId, active) {
	let changeStatusModel = {
		companyId: companyId,
		templateId: templateId,
		active: active,
	};

	const options = {
		method: "POST",
		data: changeStatusModel,
		url: `${API_URL}/api/companies/change-template-status`,
	};

	return axiosWithAuth(options);
}

function changeFeeTemplateDefault({ companyId, templateId, isDefault }) {
	return axiosWithAuth({
		url: `${API_URL}/api/companies/${companyId}/fields-templates/${templateId}/set_is_default`,
		method: "POST",
		data: { is_default: isDefault },
	});
}

function reorderFeeTemplate(model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/companies/change-template-order`,
	};

	return axiosWithAuth(options);
}

function copyFeeTemplate(companyId, templateId, name) {
	const options = {
		method: "POST",
		data: { name },
		url: `${API_URL}/api/companies/${companyId}/fields-templates/${templateId}/copy`,
	};

	return axiosWithAuth(options);
}

function deleteFeeTemplate(companyId, templateId) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/companies/${companyId}/fields-templates/${templateId}`,
	};

	return axiosWithAuth(options);
}

function saveTsysAccount(model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/companies/dataIngestSetup/createTsysAccount`,
	};

	return axiosWithAuth(options);
}

function saveRiservAccount(model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/companies/dataIngestSetup/createFdAccount`,
	};

	return axiosWithAuth(options);
}

function getTsysCredentials(companyId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/dataIngestSetup/getTsysCredentials`,
		params: { companyId },
	};

	return axiosWithAuth(options);
}

function getFDCredentials(companyId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/dataIngestSetup/getFDCredentials`,
		params: { companyId },
	};

	return axiosWithAuth(options);
}

function getAgentOfficeHierarchy({ companyId }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/hierarchy`,
	};

	return axiosWithAuth(options);
}

function getAgentOfficeHistory({ page, id }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			agentOfficeId: id,
		},
		url: `${API_URL}/api/modifications/agent_offices/${id}`,
	};

	return axiosWithAuth(options);
}

function getAgentOfficeApi({ companyId }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/api_client_credentials`,
	};

	return axiosWithAuth(options);
}

function generateAgentOfficeApi({ companyId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/companies/${companyId}/api_client_credentials/generate`,
	};

	return axiosWithAuth(options);
}

function regenerateAgentOfficeApi({ companyId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/companies/${companyId}/api_client_credentials/regenerate`,
	};

	return axiosWithAuth(options);
}

function getWhitelistedDomains({ companyId }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/whitelisted_email_domains`,
	};

	return axiosWithAuth(options);
}

function ariseBoarding(companyId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/arise/affiliates/${companyId}`,
	};

	return axiosWithAuth(options);
}
